import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { Befundmitteilung } from '../../befundmitteilung/befundmitteilung';
import { Probenbegleitschein, ProbenbegleitscheinResult } from '../probenbegleitschein';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-anzahl-proben-dialog',
    templateUrl: './anzahl-proben-dialog.component.html',
    styleUrls: ['./anzahl-proben-dialog.component.scss'],
})
export class AnzahlProbenDialogComponent implements OnInit {
    isSaving: boolean = false;
    pbgSub: Subscription;
    kategorien: string[] = ['E', 'S', 'B', 'M', 'PF', 'FB'];

    constructor(
        public dialogRef: MatDialogRef<AnzahlProbenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public pbs: Probenbegleitschein,
        private messageService: MessageService,
        private api: KieneBackendApiService,
        private router: Router,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit(): void {
        const params = new HttpParams().set('probenbegleitschein_id', this.pbs.probenbegleitschein_id.toString());
        this.pbgSub?.unsubscribe();
        this.pbgSub = this.api
            .getAll(this.apiBaseUrl + 'probenbegleitschein_untersuchungsmaterial/read.php', params)
            .subscribe({
                next: response => {
                    this.pbs.materialien = response.records;
                    for (const position of this.pbs?.materialien) {
                        if (!position.anzahl_proben) {
                            position.anzahl_proben = 1;
                        }
                    }
                },
                error: error => {
                    this.messageService.errorMessage(
                        'Probenbegleitschein: Positionen konnten nicht geladen werden!',
                        error,
                    );
                },
            });
    }

    public cancel(): void {
        const result = new ProbenbegleitscheinResult();
        result.confirm = false;
        this.dialogRef.close(result);
    }

    public save(): void {
        this.isSaving = true;
        this.api.post(this.apiBaseUrl + 'befund/transform.php', this.pbs, null).subscribe({
            next: response => {
                const b: Befundmitteilung = response;
                this.dialogRef.close();
                this.messageService.infoMessage('Die Befundmitteilung wurde erfolgreich erstellt!');
                this.router.navigate(['labor', 'befundmitteilungen', b.befund_id]);
                this.isSaving = false;
            },
            error: error => {
                this.messageService.errorMessage('Befundmitteilung konnte nicht erstellt werden!', error);
                this.isSaving = false;
            },
        });
    }

    public isDisabled(): boolean {
        return this.isSaving || this.pbs.materialien?.some(material => !material.kategorie);
    }
}
